import PropTypes from "prop-types";
import React from "react";

import asJSONLDSnippet from "./asJSONLDSnippet";
import { RETURN_POLICY } from "./boosthiveSchema";

// How many individual reviews to embed in a product's schema.org markup.
const SCHEMA_REVIEW_LIMIT = 5;

const JSONLDProductSnippet = asJSONLDSnippet(
  ({
    name,
    sku,
    url,
    description,
    image,
    inStock,
    price,
    currency,
    reviewCount,
    averageRating,
    reviews,
  }) => ({
    "@context": "https://schema.org",
    "@type": "Product",
    name,
    sku,
    description,
    ...(image && { image }),
    brand: { "@type": "Brand", name: "Boosthive" },
    offers: [
      {
        "@type": "Offer",
        url,
        availability: inStock
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock",
        price,
        priceCurrency: currency,
        seller: {
          "@type": "Organization",
          name: "Boosthive",
        },
        hasMerchantReturnPolicy: { "@type": "MerchantReturnPolicy", ...RETURN_POLICY },
      },
    ],
    ...(reviews && reviews.length > 0 && averageRating != null && {
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: averageRating,
        reviewCount,
        bestRating: 5,
      },
      review: reviews.map((review) => ({
        "@type": "Review",
        author: { "@type": "Person", name: review.publicName || "Anonymous" },
        ...(review.createdAt && { datePublished: review.createdAt }),
        ...(review.comment && { reviewBody: review.comment }),
        reviewRating: {
          "@type": "Rating",
          ratingValue: review.rating,
          bestRating: 5,
        },
      })),
    }),
  })
);

export default class JSONLDProduct extends React.PureComponent {
  static propTypes = {
    // The product's own reviews, as fetched by the page: { items, total }.
    reviews: PropTypes.object,
  };

  render() {
    const {
      name,
      sku,
      url,
      description,
      image,
      inStock,
      price,
      currency,
      reviews,
    } = this.props;

    const items = (reviews && reviews.items) || [];
    const total = (reviews && reviews.total) || 0;
    const averageRating = reviews && reviews.averageRating;

    return (
      <JSONLDProductSnippet
        name={name}
        sku={sku}
        url={url}
        description={description}
        image={image}
        inStock={inStock}
        price={price}
        currency={currency}
        reviewCount={total}
        averageRating={averageRating}
        reviews={total > 0 && items.length > 0 ? items.slice(0, SCHEMA_REVIEW_LIMIT) : undefined}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/JSON-LD/JSONLDProduct.js